import { Box, type BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Logo } from '~/assets/Logo';

type MainDrawerHeaderProps = BoxProps & {
    open?: boolean | undefined;
};

export const MainDrawerHeader = ({ open, ...props }: MainDrawerHeaderProps) => {

    return (
        <MainDrawerHeaderRoot open={open} {...props}>
            <Logo isIcon={!open} sx={{ width: open ? 'auto' : 35, height: 35 }} />
        </MainDrawerHeaderRoot>
    );
};

const MainDrawerHeaderRoot = styled(Box, {
    shouldForwardProp: prop => prop !== 'open',
})<MainDrawerHeaderProps>(
    ({ open, theme }) => ({
        ...theme.mixins.toolbar,
        display: 'flex',
        alignItems: 'center',
        justifyContent: open ? 'flex-start' : 'center',
        width: 'inherit',
        minHeight: '60px',
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(open ? 3 : 0),
        paddingBottom: theme.spacing(1),
    })
);
